import { useMemo } from "react";
import Subscription from "../Subscription";
import Transaction from "../Transaction";
import Tabs from "../../../../components/elements/Tabs";
import { useTabQuery } from "../../../../hooks/useTabQuery";
import NotFoundPage from "../../../../components/common/NotFoundPage";

const AdminPaymentsPage = () => {

  const tabs = useMemo(
    () => [
      // {
      //   label: "Subscriptions",
      //   icon: "fa-solid fa-money-check-dollar",
      //   key: "subscriptions",
      //   content: <Subscription />,
      // },
      {
        label: "Transactions",
        icon: "fa-light fa-hand-holding-dollar",
        key: "transactions",
        content: <Transaction />,
      },
    ],
    []
  );

  const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

  if (!validTab) {
    return <NotFoundPage link="/admin/payments?tab=subscriptions" />;
  }

  return (
    <Tabs
      items={tabs}
      selectedIndex={selectedIndex}
      setSelectedIndex={handleTabChange}
    />
  );
};

export default AdminPaymentsPage;
